import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material';
import React, { FC } from 'react';
import { Loader } from 'shared/components/Loader';

interface LoaderButtonProps extends ButtonProps {
  loading?: boolean;
}

export const LoaderButton: FC<LoaderButtonProps> = ({ disabled, loading, children, ...rest }) => {
  return (
    <Button disabled={Boolean(disabled || loading)} {...rest}>
      {loading ? <Loader size={24} /> : children}
    </Button>
  );
};
